module.exports = __webpack_public_path__ + "img/icon_map_3_5_c.3d8308de.png";